import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CustomersPage } from '@features/admin/customers';
import { useAdminCustomerStore } from '@features/admin/customers/useAdminCustomerStore.ts';

const adminCustomersSearchSchema = z.object({
  q: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminCustomersSearch = z.infer<typeof adminCustomersSearchSchema>;

export const Route = createFileRoute('/admin/customers/')({
  validateSearch: search => adminCustomersSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { q, page, size } = ctx.search;
    useAdminCustomerStore.getState().loadCustomers({ q, page: page || 1, size: size || 20 });
  },
});

function RouteComponent() {
  return <CustomersPage />;
}
